/*
  Boobie Bar listicle LP — scroll-to-buy for every [data-boobie-scroll] link.
  Loaded by several boobie-listicle-* sections; the guard keeps it to one listener.
  Same landing logic as boobie-donation-bar: desktop lands on the buy section,
  mobile centres the product card in the space below the fixed nav.
*/
(() => {
  if (window.boobieListicleScrollInit) return;
  window.boobieListicleScrollInit = true;

  const desktopMq = window.matchMedia('(min-width: 992px)');

  const scrollToTarget = (targetId) => {
    const target = document.getElementById(targetId);
    if (!target) return false;

    let top = target.getBoundingClientRect().top + window.scrollY - 96;
    const card = target.querySelector('.boobie-buy__card');

    if (card && !desktopMq.matches) {
      const nav = document.querySelector('.pb-unified-nav__fixed') || document.querySelector('.pb-unified-nav');
      const navBottom = nav ? Math.max(0, nav.getBoundingClientRect().bottom) : 0;
      const space = window.innerHeight - navBottom;
      const rect = card.getBoundingClientRect();
      const cardTop = rect.top + window.scrollY;
      top = rect.height < space - 24 ? cardTop - navBottom - (space - rect.height) / 2 : cardTop - navBottom - 12;
    }

    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    return true;
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-boobie-scroll]');
    if (!link) return;
    const targetId = link.dataset.boobieScroll || 'boobie-buy';
    if (scrollToTarget(targetId)) event.preventDefault();
  });
})();
